import styled, { css } from "styled-components";
import { Map } from "@styled-icons/boxicons-regular/Map";
import { Phone } from "@styled-icons/fa-solid/Phone";
import { EnvelopeFill } from "@styled-icons/bootstrap/EnvelopeFill";
import { Globe } from "@styled-icons/fa-solid/Globe";
const titles = css`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 150px;
`;
export const Container = styled.div`
  ${({ title }) => title && titles};
  /* margin-bottom: 60px; */
  user-select: none;
  @media (max-width: 1049px) {
    /* padding: 0 20px; */
    /* width: 100%; */
  }
  animation: meals-appear 1s ease-out forwards;

  @keyframes meals-appear {
    from {
      opacity: 0;
      transform: translateY(6rem);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const Range = css`
  ::before {
    content: "";
    position: absolute;
    top: 10px;
    left: 50%;
    width: 150px;
    height: 4px;
    background: crimson;
    transform: translateX(-50%);
  }
  ::after {
    content: "";
    position: absolute;
    top: 3px;
    left: 50%;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: crimson;
    transform: translateX(-50%);
  }
  margin-bottom: 60px;
`;
const Tag = css`
  color: #111;
  font-weight: 700;
  margin: 10px;
  text-align: center;
`;
const Info = css`
  color: #666;
  font-weight: 500;
`;
const Contact = css`
  color: #111;
  font-size: 25px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 40px;
`;

export const Title = styled.div`
  position: relative;
  color: ${({ main }) => (main ? "crimson" : "black")};
  font-size: ${({ title }) => (title ? "35px" : "20px")};
  font-weight: 800;
  ${({ range }) => range && Range};
  ${({ title }) => title && Tag};
  ${({ info }) => info && Info};
  ${({ contact }) => contact && Contact}
`;

const Content = css`
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex-wrap: wrap;
  margin-top: 20px;
`;
const Card = css`
  background: #fff;
  width: 320px;
  height: 280px;
  margin: 20px;
  padding: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: transform 0.5s ease;
  border-radius: 10px;
  box-shadow: 0 5px 25px rgba(1 1 1 / 15%);
  :hover {
    cursor: pointer;
    transform: scale(1.1);
  }
`;
const Row = css`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: row;
  /* width: 400px; */
  width: 100%;
`;
const Icon = css`
  text-align: center;
  transition: transform 0.5s ease;
  :hover {
    transform: translateY(-10px);
  }
`;
const InfoWrapper = css`
  display: flex;
  flex-direction: column;
`;

export const Form = styled.form`
  max-width: 600px;
  background: #fff;
  margin-top: 50px;
  padding: 50px;
  border-radius: 10px;
  box-shadow: 0 5px 25px rgba(1 1 1 /15%);
`;

const InputBox = css`
  position: relative;
  width: 100%;
  margin-bottom: 20px;
`;
export const Wrapper = styled.div`
  ${({ content }) => content && Content};
  ${({ card }) => card && Card};
  ${({ row }) => row && Row};
  ${({ icon }) => icon && Icon};
  ${({ info }) => info && InfoWrapper};
  ${({ contactForm }) => contactForm && Form};
  ${({ input }) => input && InputBox}
`;

export const Icons = styled.div``;
Icons.Map = styled(Map)`
  width: 100px;
  color: crimson;
  text-align: center;
`;
Icons.Phone = styled(Phone)`
  width: 80px;
  color: crimson;
`;
Icons.EnvelopeFill = styled(EnvelopeFill)`
  width: 100px;
  color: crimson;
`;
Icons.Globe = styled(Globe)`
  width: 100px;
  color: crimson;
`;
const isValidStyle = css`
  border: ${({ isValid }) => (!isValid ? "solid 2px red" : "solid 1px #111")};
  background-color: ${({ isValid }) => (!isValid ? "#fdd3ce" : "transparent")};
  ::placeholder {
    color: ${({ isValid }) => (!isValid ? "red" : "gray")};
  }
  :active {
    ${({ isValid }) => (!isValid ? "#fdd3ce" : "transparent")}
  }
`;
export const Input = styled.input`
  width: 100%;
  color: #111;
  outline: none;
  padding: 10px;
  font-size: 17px;
  font-weight: 400;
  ${({ isValid }) => !isValid && isValidStyle}
  :focus {
    border: ${({ isValid }) => (isValid ? "2px solid green" : "2px solid red")};
    /* background-color: #fdd3ce; */
    ::placeholder {
      color: #000;
    }
  }
`;

export const Text = styled.textarea`
  resize: none;
  border: solid 1px #111;
  width: 100%;
  color: #111;
  outline: none;
  padding: 10px;
  font-size: 17px;
  font-weight: 400;
  ${({ isValid }) => !isValid && isValidStyle}
  &:focus {
    /* background-color: #fdd3ce; */
    border: 2px solid green;
    ::placeholder {
      color: #000;
    }
  }
`;

export const Button = styled.button`
  @media (max-width: 745px) {
    width: 100%;
  }
  width: auto;
  margin-top: 20px;
  background: crimson;
  display: inline-block;
  user-select: none;
  padding: 10px 20px;
  border-radius: 10px;
  letter-spacing: 2px;
  font-size: 19px;
  color: #fff;
  font-weight: 500;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  transition: 0.5s ease;
  :hover {
    background: #000;
    color: white;
  }
  :active {
    transform: scale(0.95);
  }
  /* opacity: ${({ disabledBtn }) => (disabledBtn ? "0.1" : "1")}; */
`;
export const ErrorMessage = styled.p`
  color: red;
`;

// export const RequestSubmitted = styled.div`
//   width: 200px;
// `;
